import { render, staticRenderFns } from "./LightR6.vue?vue&type=template&id=6fbc082d&scoped=true&"
import script from "./LightR6.vue?vue&type=script&lang=js&"
export * from "./LightR6.vue?vue&type=script&lang=js&"
import style0 from "./LightR6.vue?vue&type=style&index=0&id=6fbc082d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc082d",
  null
  
)

export default component.exports